<template>
    <div class="register-form">
        <div class="form-body">
            <div class="form-title">版师入驻申请</div>
            <div class="form-desc">一站式管理打版订单,高效对接需求,保障收益计算</div>
            <div class="form">
                <div class="form-item-col-2">
                    <div class="form-item-input">
                        <div class="form-item-label required">您的姓名</div>
                        <div class="form-item-value">
                            <input type="text" v-model="form_data.name" placeholder="请输入您的姓名" />
                        </div>
                    </div>
                    <div class="form-item-input">
                        <div class="form-item-label required">从业年限</div>
                        <div class="form-item-value">
                            <Select placeholder="请选择" v-model="form_data.work_year" size="large" style="height:100%;">
                                <Option v-for="item in 30" :key="item" :value="item">{{item}}年</Option>
                            </Select>
                        </div>
                    </div>
                </div>
                <div class="form-item-col-2">
                    <div class="form-item-input">
                        <div class="form-item-label required">手机号码</div>
                        <div class="form-item-value">
                            <input type="text" v-model="form_data.mobile" placeholder="请输入您的手机号码" />
                        </div>
                    </div>
                    <div class="form-item-input">
                        <div class="form-item-label required">邮箱</div>
                        <div class="form-item-value">
                            <input type="text" v-model="form_data.email" placeholder="请输入您的邮箱" />
                        </div>
                    </div>
                </div>
                <div class="form-item-col-1">
                    <div class="form-item-input">
                        <div class="form-item-label">常驻地址</div>
                        <div class="form-item-value">
                            <input type="text" v-model="form_data.live_address" placeholder="请输入您的常驻地址" />
                        </div>
                    </div>
                </div>
                <div class="form-item-col-1">
                    <div class="form-item-input">
                        <div class="form-item-label">身份证</div>
                        <div class="form-item-value-upload">
                            <Upload action="/" :before-upload="(file)=>onBeforeUpload(file,'front')" :data="{dir:'template'}" >
                                <div class="upload-item">
                                    <div class="img-item">
                                        <img v-if="idFront" src="@/assets/images/icon-close-circle.png" alt="" class="delete-ico" @click.stop="onDeleteImg('front')" />
                                        <img :src="idFront || require('@/assets/images/bg-id-card-front.png')" alt="" />
                                    </div>
                                    <div class="item-title">上传身份证正面(头像面)</div>
                                </div>
                            </Upload>
                            <Upload action="/" :before-upload="(file)=>onBeforeUpload(file,'back')" :data="{dir:'template'}" >
                                <div class="upload-item">
                                    <div class="img-item">
                                        <img v-if="idBack" src="@/assets/images/icon-close-circle.png" alt="" class="delete-ico" @click.stop="onDeleteImg('back')" />
                                        <img :src="idBack || require('@/assets/images/bg-id-card-back.png')" alt="" />
                                    </div>
                                    <div class="item-title">上传身份证反面(国徽面)</div>
                                </div>
                            </Upload>
                            <ul>
                                <li>支持JPG/PNG/JPEG格式的图片</li>
                                <li>图片大小≤3M</li>
                                <li>确保身份证有效,头像文字清晰,四角完整,无反光无遮挡</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div class="form-item-col-1">
                    <div class="form-item-input">
                        <div class="form-item-label-with-remark">
                            <div class="required">擅长品类</div>
                            <div class="remark">(可多选)</div>
                        </div>
                        <CheckboxGroup v-model="form_data.cates" class="form-item-value-checkbox"> 
                            <div v-for="(item,index) in category_list" :key="index" class="checkbox-item" :title="item.name">
                                <Checkbox :label="item.id">{{item.name}}</Checkbox>
                            </div>
                        </CheckboxGroup>
                    </div>
                </div>
                <div class="form-item-col-half">
                    <div class="form-item-input">
                        <div class="form-item-label required">
                            所在地区
                        </div>
                        <div class="form-item-value">
                            <Cascader placeholder="请选择" size="large" :data="region" v-model="area" style="height:100%;" @on-change="onAreaChange"> 
                            </Cascader>
                        </div>
                    </div>
                </div>
                <div class="form-item-col-1">
                    <div class="form-item-input">
                        <div class="form-item-label required">工作情况</div>
                        <RadioGroup v-model="form_data.work_type" class="form-item-value-radio">
                            <Radio label="0" class="radio-item">在职</Radio>
                            <Radio label="1" class="radio-item">兼职</Radio>
                            <Radio label="2" class="radio-item">自由职业</Radio>
                        </RadioGroup>
                    </div>
                </div>
                <div class="form-item-col-1">
                    <div class="form-item-input">
                        <div class="form-item-label required">可接单时间</div>
                        <RadioGroup v-model="form_data.work_time" class="form-item-value-radio">
                            <Radio label="0" class="radio-item">24小时全天候</Radio>
                            <Radio label="1" class="radio-item">晚上</Radio>
                            <Radio label="2" class="radio-item">周末</Radio>
                            <Radio label="3" class="radio-item">晚上及周末</Radio>
                        </RadioGroup>
                    </div>
                </div>
            </div>
            <Checkbox v-model="agree" class="form-agree">我已阅读并同意<div @click="onServiceRuleClick('patternMaker')">《版师服务协议》</div>和<div @click="onServiceRuleClick('privacy')">《隐私政策》</div></Checkbox>
            <div class="form-submit">
                <div :class="['submit-btn',{disabled:!submitDisabled}]" @click="onSubmit">提交</div>
            </div>
        </div>
        <popup :show.sync="is_popup_show" width="680px" height="520px" @on-close="is_popup_show=false">
			<div class="agree-content">
				<div v-html="agree_type == 'patternMaker' ? setting.patternMakerAgreement : setting.patternMakerPrivacy"></div>
			</div>
		</popup>
    </div>
</template>
<script>
import { applyPM, categoryList, patternMakerInfo } from '@/api/index';
import Popup from '@/components/Popup';
import { uploadFileToOSS } from "@/utils/oss";
import region from "@/utils/region.js";
import { mapState } from 'vuex';
export default{
    components:{
        Popup
    },
    data(){
        return{
            region,
            form_data:{
                cates:[],
                name:'',
                province:'',
                city:'',
                zone:'',
                work_type:'',
                work_time:'',
                work_year:'',
                from_site:'0'
            },
            agree:false,
            area:[],
            category_list:[],
            is_popup_show:false,
            agree_type:''
        }
    },
    watch:{
        'form_data.category'(news,olds){
            console.log('news',news,'olds',olds);
        }
    },
    computed:{
        ...mapState({
            setting: (state) => state.setting,
            userInfo:(state)=>state.userInfo
        }),
        idFront(){
            const {id_card} = this.form_data;
            if(!id_card) return '';
            const data = id_card.find(item=>{return item.id_front});
            return data?data.id_front:'';
        },
        idBack(){
            const {id_card} = this.form_data;
            if(!id_card) return '';
            const data = id_card.find(item=>{return item.id_back});
            return data?data.id_back:'';
        },
        submitDisabled(){
            return this.form_data.name &&     
           this.form_data.cates.length > 0 && 
           this.form_data.province && 
           this.form_data.city && 
           this.form_data.zone && 
           this.form_data.work_type !== '' && 
           this.form_data.work_time !== '';
        },
    },
    mounted(){
        this.onGetProductCateList();
        console.log('mounted-pm-reg');
        if(this.$route.query.reApply){
            this.onGetInfo();
        }
    },
    methods:{
        async onGetInfo(){
            try{
                const {code,msg,data} = await patternMakerInfo();
                if(code > 0){
                    this.$layer.msg(msg);
                    return;
                }
                this.form_data = {...data,cates:data.cates_id.map(item=>{return Number(item)}),work_type:data.work_type_val ? data.work_type_val.toString(): '0',work_time:data.work_time_val ? data.work_time_val.toString(): '0'}
                this.area = [data.province,data.city,data.zone];
            }catch(e){
                console.log('err',e);
            }
        },
        onAreaChange(value){ 
            console.log('value',value);
            this.$set(this.form_data,'province',value[0]);
            this.$set(this.form_data,'city',value[1]);
            this.$set(this.form_data,'zone',value[2]);
        },
        async onGetProductCateList(){
            try{
                const {data} = await categoryList();
                this.category_list = data;
                // console.log('data->cate',data);
            }catch(e){
                console.log('err->cate',e);
            }
        },
        onDeleteImg(type){
            if(type === 'front'){
                this.form_data.id_card = this.form_data.id_card.filter(item=>{return item.id_back});
            }else{
                this.form_data.id_card = this.form_data.id_card.filter(item=>{return item.id_front});
            }
        },
        async onBeforeUpload(file,field) {
            console.log("file-before", file,field);
            try {
                const url = await uploadFileToOSS(file, "template");
                console.log('url==>',url);
                    if(!this.form_data.id_card){
                        this.$set(this.form_data,'id_card',[]);
                    }
                    switch(field){
                        case 'front':{
                            const findFront = this.form_data.id_card.findIndex((item)=>{return item.id_front});
                            if(findFront !== -1){
                                this.form_data.id_card[findFront].id_front = url;
                            }else{
                                this.form_data.id_card.push({id_front:url});
                            }
                            break;
                        }
                        case 'back':{
                            const findBack = this.form_data.id_card.findIndex((item)=>{return item.id_back});
                            if(findBack !== -1){
                                this.form_data.id_card[findBack].id_back = url;
                            }else{
                                this.form_data.id_card.push({id_back:url});
                            }
                            break;
                        }
                    }


            } catch (err) {
            this.$layer.msg(`上传失败==>：${file.name}`);
            }
            return false;
        },
        async onSubmit(){
            try{
                console.log('form_data',this.form_data);
                if(!this.agree){
                    this.$layer.msg('请先阅读并同意版师服务协议和隐私政策');
                    return;
                }
                if(!this.submitDisabled){
                    this.$layer.msg('请填写完整信息');
                    return;
                }
                const {code,msg} = await applyPM(this.form_data);
                if(code>0){
                    this.$layer.msg(msg);
                    return;
                }
                this.$layer.msg('申请成功');
                this.$router.push({name:'PMResult',query:{type:'apply'}})
            }catch(e){
                console.log('err-apply-pm',e);
                this.$layer.msg(e.msg);
            }
        },
        onServiceRuleClick(type){
            this.agree_type = type;
            this.is_popup_show = true;
        }
    }
}
</script>
<style lang="scss" scoped>
.register-form{
    width:100%;
    min-height:100vh;
    background:#f5f9fc;
    display:flex;
    justify-content:center;
    padding-bottom:80px;
    user-select: none;
    .form-body{
        width:100%;
        max-width:1000px;
        margin-top:28px;
        background:#fff;
        border-radius:10px;
        box-shadow:0px 0px 8px 4px rgba(1,32,55,0.05);
        .form-title{
            width:100%;
            text-align:center;
            color:#333;
            font-weight:bold;
            font-size:28px;
            margin-top:30px;
        }
        .form-desc{
            margin-top:8px;
            text-align:center;
            width:100%;
            color:#666;
            font-size:14px;
            padding-bottom:24px;
            border-bottom:1px solid #ebebeb;
        }
        .form{
            width:100%;
            padding:0 50px;
            margin-top:28px;
            .form-item-input{
                flex:1;
                display:flex;
                flex-direction:column;
                row-gap:16px;
                margin-bottom:32px;
                .form-item-label{
                    color:#333;
                    font-size:14px;
                    &.required::after{
                        content:"*";
                        color:red;
                    }
                }
                .form-item-label-with-remark{
                    color:#333;
                    font-size:14px;
                    display:flex;
                    align-items:center;
                    column-gap:5px;
                    .required::after{
                        content:"*";
                        color: red;
                    }
                    .remark{
                        color:#666;
                    }
                }
                .form-item-value{
                    width:100%;
                    height:50px;
                    border:1px solid #e3e3e3;
                    border-radius:8px;
                    overflow:hidden;
                    input{
                        border:none;
                        outline:none;
                        width:100%;
                        height:100%;
                        padding:0 16px;
                        &:focus{
                            border:none;
                            border-color:transparent !important;
                        }
                    }
                    ::v-deep .ivu-select-selection{
                        height:100%;
                        display:flex;
                        align-items:center;
                        border:none;
                    }
                    ::v-deep .ivu-select-placeholder{
                        color:#999;
                    }
                    ::v-deep .ivu-cascader-rel{
                        height:100%;
                        border:none;
                        outline:none;
                        display:flex;
                        align-items:center;
                    }
                    ::v-deep .ivu-cascader{
                        height:100%;
                        display:flex;
                        align-items:center;
                        border:none;
                    }
                    ::v-deep .ivu-input{
                        border:none;
                        outline:none;
                        height:100%;
                        &:focus{
                            border-color:transparent !important;
                            box-shadow:none !important;
                            -webkit-box-shadow:none !important;
                        }
                    }
                }
                .form-item-value-upload{
                    width:100%;
                    display:flex;
                    align-items:center;
                    column-gap:16px;
                    .upload-item{
                        width:260px;
                        display:flex;
                        flex-direction:column;
                        align-items:center;
                        row-gap:12px;
                        cursor:pointer;
                        .img-item{
                            width:100%;
                            height:176px;
                            // border-radius:10px;
                            border:1px dashed #e3e3e3;
                            overflow:hidden;
                            position:relative;
                            .delete-ico{
                                position:absolute;
                                top:4px;
                                right:4px;
                                width:20px;
                                height:20px;
                                cursor:pointer;
                            }
                            img{
                                width:100%;
                                height:100%;
                                object-fit: cover;
                                object-position: center;
                                border-radius:10px;
                            }
                        }
                        .item-title{
                            color:#999;
                            font-size:12px;
                        }
                    }
                    ul li{
                        color:#999;
                        font-size:12px;
                        margin-left:22px;
                    }
                }
                .form-item-value-checkbox{
                    display:flex;
                    flex-wrap:wrap;
                    gap:12px;
                    .checkbox-item{
                        width:140px;
                        height:42px;
                        border:1px solid #e3e3e3;
                        border-radius:4px;
                        display:flex;
                        align-items:center;
                        padding-left:16px;
                        white-space:nowrap;
                        overflow:hidden;
                        text-overflow:ellipsis;
                        ::v-deep .ivu-checkbox-checked .ivu-checkbox-inner {
                            border-color: #ff5967;
                            background-color: #ff5967;
                        }
                    }
                }
                .form-item-value-radio{
                    display:flex;
                    align-items: center;
                    .radio-item{
                        width:100px;
                        height:42px;
                        display:flex;
                        align-items:center;
                        justify-content: center;
                        white-space:nowrap;
                        overflow:hidden;
                        text-overflow: ellipsis;
                    }
                }
            }
        }
        .form-agree{
            display:flex;
            align-items:center;
            column-gap:5px;
            color:#666;
            font-size:14px;
            padding-left:50px;
            margin-top:35px;
            div{
                cursor:pointer;
            }
        }
        .form-submit{
            width:100%;
            display:flex;
            align-items:center;
            justify-content:center;
            margin-top:57px;
            margin-bottom:60px;
            .submit-btn{
                width:220px;
                height:48px;
                border-radius:8px;
                background:#ff5967;
                color:#fff;
                cursor:pointer;
                font-size:16px;
                text-align:center;
                line-height:48px;
                &.disabled{
                    background:rgba(255,89,103,0.5);
                    cursor:not-allowed;
                }
            }
        }
    }
}
.form-item-col-2{
    display:flex;
    align-items:center;
    column-gap:20px;
}
.form-item-col-1{
    width:100%;
    display:flex;
    align-items:center;
}
.form-item-col-half{
    width:50%;
    display:flex;
    align-items:center;
}

::v-deep .ivu-radio-checked .ivu-radio-inner {
    border-color: rgb(255, 89, 103);
}

::v-deep .ivu-radio-focus {
    -webkit-box-shadow: 0 0 0 2px rgba(255, 89, 103, .2);
    box-shadow: 0 0 0 2px rgba(255, 89, 103, .2);
    z-index: 1;
}

::v-deep .ivu-radio-inner:after{
    background-color:#ff5967;
}

::v-deep .popup-modal {
  /* 弹窗内容区 */
  .popup-content {
    /* 修正后 */
    width: max(980px, 96vw); // 增加视口占比
    min-width: 320px; // 保障最小可操作宽度
    max-width: none !important; // 移除潜在限制

    /* 添加边距保护 */
    margin: 0 2vw; // 左右留白
    box-sizing: content-box; // 防止padding影响
    max-height: max(500px, 80vh); // 最大720px，最小占85%视口高
    min-height: 30vh;
    // height:100%;
    display: flex;
    flex-direction: column;
    .agree-content {
      overflow-y: scroll;
      height:100%;
      max-height: max(30vh, 70vh); // 最大720px，最小占85%视口高
      padding: 30px 30px 0 30px;;
      &::-webkit-scrollbar {
        width: 0px;
        background: transparent;
      }

      &::-webkit-scrollbar-thumb {
        background: #ddd;
        border-radius: 3px;
      }
    }
  }
}
</style>